export const NAVIGATION_WIDTH_VALUE = 256;
export const NAVIGATION_WIDTH = `${NAVIGATION_WIDTH_VALUE}px`;
export const NAVIGATION_WIDTH_COLLAPSED = '68px';
export const ITEMS_LIST_PADDING_VALUE = 10;
export const ITEMS_LIST_PADDING = `${ITEMS_LIST_PADDING_VALUE}px`;
export const COLLAPSING_TRANSITION = '.25s';
export const DEFAULT_TRANSITION = '.15s';
const SPACER_DEFAULT_VALUE = 16;
export const SPACER_DEFAULT = `${SPACER_DEFAULT_VALUE}px`;
export const SUBMENU_VIEWPORT_OFFSET = '30px';
